// extracted by mini-css-extract-plugin
export default {"container":"ctiyouk","copyContainer":"pSrPImZ","navAppLogo":"rXoAy0b","bannerText":"F0f4XF_ sOoULa1 leavesden4","ctaButton":"WVPdP42"};